import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import {PerioTooth, PerioDisplayTooth, PerioDisplayToothIssues} from '../models/perio.models';
import {PerioService} from '../services/perio.service';

@Component({
  standalone: false,
  selector: 'app-perio-tooth',
  templateUrl: './perio-tooth.component.html',
  styleUrls: ['./perio-tooth.component.css'],
})
export class PerioToothComponent implements OnInit {

  @Input() imageIndex: number;
  @Input() tooth: PerioTooth;
  @Input() facing: string; // buccal or lingual
  @Input() section: string; // upper or lower
  @Input() displayToothId: boolean;
  @Input() selected: boolean;

  toothImageSrc: SafeResourceUrl;
  toothImageSrcImplant: SafeResourceUrl;
  displayTooth: PerioDisplayTooth;
  displayToothIssues: PerioDisplayToothIssues;
  saveSubscriptionOrganizer: any = {};

  constructor(
    private sanitizer: DomSanitizer,
    private perioService: PerioService
  ) { }

  ngOnInit() {
    this.buildSrc();
    //this.initPerioLines();

    if (this.selected) {
      // console.log(this.selected);
      // console.log(this.tooth);
    }

  }

  buildSrc() {

    const section: string = this.section === 'upper' ? 'Upper' : 'Lower';
    const facing: string = this.facing === 'buccal' ? 'B' : 'L';
    let index: string;
    let sectionImplant: string = null;

    if (this.facing === 'buccal'){
        if (this.section === 'upper') {
            sectionImplant = 'Upper';
        }
        else {
          sectionImplant = 'Lower';
        }
      }
    if (this.facing === 'lingual'){
      if (this.section === 'upper') {
        sectionImplant = 'Lower';
      }
      else {
        sectionImplant = 'Upper';
      }
    }


    if (this.imageIndex < 9) {
      index = `0${this.imageIndex + 1}`;
    } else {
      index = `${this.imageIndex + 1}`;
    }

    // let imageSrc: string = `assets/teeth-images/${section}/${index}_${facing}_${section}_Jaw.png`; // OLD
    const imageSrc: string = `assets/teeth-images/${section}/${section}_${facing}_${index}.PNG`;
    const imageSrcImplant: string = `assets/teeth-images/Implants/Implant_${sectionImplant}.png`;
    this.toothImageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(imageSrc);
    this.toothImageSrcImplant = this.sanitizer.bypassSecurityTrustResourceUrl(imageSrcImplant);
  }

  initPerioLines() {

    this.displayTooth = {
      tooth: this.parseToothId(this.tooth.ToothId),
      FacialProbingDepth: '',
      FacialGingovalMargin: '',
      FacialClinicalAttachmentLevel: '',
      FacialMucogingovalJunction: '',
      FacialFurcationGrade: '',
      LingualProbingDepth: '',
      LingualGingovalMargin: '',
      LingualClinicalAttachmentLevel: '',
      LingualMucogingovalJunction: '',
      LingualFurcationGrade: ''
    };

    if (this.facing === 'buccal') {
      this.drawPerioLine('FacialProbingDepth', this.tooth.FacialProbingDepthD, this.tooth.FacialProbingDepthC, this.tooth.FacialProbingDepthM);
      this.drawPerioLine('FacialGingovalMargin', this.tooth.FacialGingovalMarginD, this.tooth.FacialGingovalMarginC, this.tooth.FacialGingovalMarginM);
      this.drawPerioLine('FacialClinicalAttachmentLevel', this.tooth.FacialClinicalAttachmentLevelD, this.tooth.FacialClinicalAttachmentLevelC, this.tooth.FacialClinicalAttachmentLevelM);
      this.drawPerioLine('FacialMucogingovalJunction', this.tooth.FacialMucogingovalJunctionD, this.tooth.FacialMucogingovalJunctionC, this.tooth.FacialMucogingovalJunctionM);
      // this.drawPerioLine("FacialFurcationGrade", this.tooth.FacialFurcationGradeD, this.tooth.FacialFurcationGradeC, this.tooth.FacialFurcationGradeM);
    } else {

      this.drawPerioLine('LingualProbingDepth', this.tooth.LingualProbingDepthD, this.tooth.LingualProbingDepthC, this.tooth.LingualProbingDepthM);
      this.drawPerioLine('LingualGingovalMargin', this.tooth.LingualGingovalMarginD, this.tooth.LingualGingovalMarginC, this.tooth.LingualGingovalMarginM);
      this.drawPerioLine('LingualClinicalAttachmentLevel', this.tooth.LingualClinicalAttachmentLevelD, this.tooth.LingualClinicalAttachmentLevelC, this.tooth.LingualClinicalAttachmentLevelM);
      this.drawPerioLine('LingualMucogingovalJunction', this.tooth.LingualMucogingovalJunctionD, this.tooth.LingualMucogingovalJunctionC, this.tooth.LingualMucogingovalJunctionM);
      // this.drawPerioLine("LingualFurcationGrade", this.tooth.LingualFurcationGradeD, this.tooth.LingualFurcationGradeC, this.tooth.LingualFurcationGradeM);
    }
  }

  initIssuesDot() {
    console.log('initialazing with Issues  ' + this.tooth.ToothId + ' - facing' + this.facing);
    this.displayToothIssues = {
      tooth: this.parseToothId(this.tooth.ToothId),
      FacialBleeding: '',
      FacialSuppuration: '',
      FacialPlaque: '',
      FacialCalculus: '',
      LingualBleeding: '',
      LingualSuppuration: '',
      LingualPlaque: '',
      LingualCalculus: '',
    };

    if (this.facing === 'buccal') {
      this.drawIssuesDot('FacialBleeding', this.tooth.FacialBleedingD, this.tooth.FacialBleedingC, this.tooth.FacialBleedingM);
      this.drawIssuesDot('FacialSuppuration', this.tooth.FacialSuppurationD, this.tooth.FacialSuppurationC, this.tooth.FacialSuppurationM);
      this.drawIssuesDot('FacialPlaque', this.tooth.FacialPlaqueD, this.tooth.FacialPlaqueC, this.tooth.FacialPlaqueM);
      this.drawIssuesDot('FacialCalculus', this.tooth.FacialCalculusD, this.tooth.FacialCalculusD, this.tooth.FacialCalculusD);
      // this.drawPerioLine("FacialFurcationGrade", this.tooth.FacialFurcationGradeD, this.tooth.FacialFurcationGradeC, this.tooth.FacialFurcationGradeM);
    } else {

      this.drawIssuesDot('LingualBleeding', this.tooth.LingualBleedingD, this.tooth.LingualBleedingC, this.tooth.LingualBleedingM);
      this.drawIssuesDot('LingualSuppuration', this.tooth.LingualSuppurationD, this.tooth.LingualSuppurationC, this.tooth.LingualSuppurationM);
      this.drawIssuesDot('LingualPlaque', this.tooth.LingualPlaqueD, this.tooth.LingualPlaqueC, this.tooth.LingualPlaqueM);
      this.drawIssuesDot('LingualCalculus', this.tooth.LingualCalculusD, this.tooth.LingualCalculusC, this.tooth.LingualCalculusM);
      // this.drawPerioLine("LingualFurcationGrade", this.tooth.LingualFurcationGradeD, this.tooth.LingualFurcationGradeC, this.tooth.LingualFurcationGradeM);
    }
  }






  parseToothId(toothId: string) {
    return toothId.substr(toothId.length - 2, toothId.length);
  }


  onValueChange(){
    this.saveTooth(this.tooth);
  }


  saveTooth(tooth: PerioTooth) {

    const toothClone: PerioTooth = JSON.parse(JSON.stringify(tooth));
    toothClone.cfgTooth = null;

    if (this.saveSubscriptionOrganizer[tooth.PerioChartToothID] && !this.saveSubscriptionOrganizer[tooth.PerioChartToothID].closed) {
      try {
        this.saveSubscriptionOrganizer[tooth.PerioChartToothID].unsubscribe();
      } catch (err) { }
    }

    this.saveSubscriptionOrganizer[tooth.PerioChartToothID] = this.perioService.savePerioTooth(toothClone)
      .subscribe(response => {
      }, err => {
        console.log('ERROR SAVING', err);
      });

  }


  drawPerioLine(parameter: string, vD: number, vC: number, vM: number) {
    const leftMargin = 0;
    const rightMargin = 0;

    const gumLineUF: number = 70;
    const gumLineUL: number = 70;
    const gumLineLL: number = 45;
    const gumLineLF: number = 37;

    const svgWidth = 66;
    const multiplier: number = 30 / 9;

    const displayTooth = this.displayTooth;

    if (this.section === 'upper') {
      // FACIAL

      if (parameter === 'FacialProbingDepth') {
        displayTooth.FacialProbingDepth = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialGingovalMargin') {
        displayTooth.FacialGingovalMargin = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialClinicalAttachmentLevel') {
        displayTooth.FacialClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialMucogingovalJunction') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialFurcationGrade') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }

      // LINGUAL
      if (parameter === 'LingualProbingDepth') {
        displayTooth.LingualProbingDepth = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }
      if (parameter === 'LingualGingovalMargin') {
        displayTooth.LingualGingovalMargin = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }
      if (parameter === 'LingualClinicalAttachmentLevel') {
        displayTooth.LingualClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }
      if (parameter === 'LingualMucogingovalJunction') {
        displayTooth.LingualMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }
      if (parameter === 'LingualFurcationGrade') {
        displayTooth.LingualFurcationGrade = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }
    }

    if (this.section === 'lower') {

      // FACIAL
      if (parameter === 'FacialProbingDepth') {
        displayTooth.FacialProbingDepth = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialGingovalMargin') {
        displayTooth.FacialGingovalMargin = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialClinicalAttachmentLevel') {
        displayTooth.FacialClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialMucogingovalJunction') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialFurcationGrade') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }


      // LINGUAL
      if (parameter === 'LingualProbingDepth') {
        displayTooth.LingualProbingDepth = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualGingovalMargin') {
        displayTooth.LingualGingovalMargin = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualClinicalAttachmentLevel') {
        displayTooth.LingualClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualMucogingovalJunction') {
        displayTooth.LingualMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualFurcationGrade') {
        displayTooth.LingualFurcationGrade = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
    }


  }

  drawIssuesDot(parameter: string, issueD: boolean, issueC: boolean, issueM: boolean) {

    console.log('draw Dot ' + parameter);
    const leftMargin = 0;
    const rightMargin = 0;

    const gumLineUF: number = 70;
    const gumLineUL: number = 70;
    const gumLineLL: number = 45;
    const gumLineLF: number = 37;

    const svgWidth = 66;
    const multiplier: number = 30 / 9;

    const displayToothIssue = this.displayToothIssues;

    if (this.section === 'upper') {
      // FACIAL

      if (parameter === 'FacialBleeding') {
        displayToothIssue.FacialBleeding = '' +
          leftMargin + ',' + (gumLineUF - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(issueM) * multiplier);
        console.log('FacialBleeding' + displayToothIssue.FacialBleeding);
      }
      if (parameter === 'FacialSuppuration') {
        displayToothIssue.FacialSuppuration = '' +
          leftMargin + ',' + (gumLineUF - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(issueM) * multiplier);
      }
      if (parameter === 'FacialCalculus') {
        displayToothIssue.FacialCalculus = '' +
          leftMargin + ',' + (gumLineUF - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(issueM) * multiplier);
      }
      if (parameter === 'FacialPlaque') {
        displayToothIssue.FacialPlaque = '' +
          leftMargin + ',' + (gumLineUF - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(issueM) * multiplier);
      }
      /*if (parameter === 'FacialFurcationGrade') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineUF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUF - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUF - Number(vM) * multiplier);
      }*/

      // LINGUAL
      if (parameter === 'LingualBleeding') {
        displayToothIssue.LingualBleeding = '' +
          leftMargin + ',' + (gumLineUL - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(issueM) * multiplier);
      }
      if (parameter === 'LingualSuppuration') {
        displayToothIssue.LingualSuppuration = '' +
          leftMargin + ',' + (gumLineUL - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(issueM) * multiplier);
      }
      if (parameter === 'LingualCalculus') {
        displayToothIssue.LingualCalculus = '' +
          leftMargin + ',' + (gumLineUL - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(issueC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(issueM) * multiplier);
      }
      if (parameter === 'LingualPlaque') {
        displayToothIssue.LingualPlaque = '' +
          leftMargin + ',' + (gumLineUL - Number(issueD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(issueD) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(issueD) * multiplier);
      }
      /*if (parameter === 'LingualFurcationGrade') {
        displayTooth.LingualFurcationGrade = '' +
          leftMargin + ',' + (gumLineUL - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineUL - Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineUL - Number(vM) * multiplier);
      }*/
    }

    /*if (this.section === 'lower') {

      // FACIAL
      if (parameter === 'FacialProbingDepth') {
        displayTooth.FacialProbingDepth = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialGingovalMargin') {
        displayTooth.FacialGingovalMargin = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialClinicalAttachmentLevel') {
        displayTooth.FacialClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }
      if (parameter === 'FacialMucogingovalJunction') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLF + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF - Number(vM) * multiplier);
      }
      if (parameter === 'FacialFurcationGrade') {
        displayTooth.FacialMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLF - Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLF + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLF + Number(vM) * multiplier);
      }


      // LINGUAL
      if (parameter === 'LingualProbingDepth') {
        displayTooth.LingualProbingDepth = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualGingovalMargin') {
        displayTooth.LingualGingovalMargin = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualClinicalAttachmentLevel') {
        displayTooth.LingualClinicalAttachmentLevel = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualMucogingovalJunction') {
        displayTooth.LingualMucogingovalJunction = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
      if (parameter === 'LingualFurcationGrade') {
        displayTooth.LingualFurcationGrade = '' +
          leftMargin + ',' + (gumLineLL + Number(vD) * multiplier) + ' ' +
          (leftMargin + ((svgWidth - leftMargin - rightMargin) / 2)) + ',' + (gumLineLL + Number(vC) * multiplier) + ' ' +
          (svgWidth - rightMargin) + ',' + (gumLineLL + Number(vM) * multiplier);
      }
    }*/


  }

}
